<template>
  <div class="container" id="goods-edit">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <el-breadcrumb separator="">
        <el-breadcrumb-item>
          <div class="div1">矩阵管理</div>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <div class="div2">申请详情</div>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content page-title">
      <h2>申请详情</h2>
    </div>
    <div class="content">
      <h3>基本信息</h3>
      <el-form
        :model="infoForm"
        ref="infoForm"
        label-width="130px"
        class="info-form"
      >
        <el-form-item label="用户姓名">
          <el-input
            placeholder="请输入用户姓名"
            v-model="infoForm.name"
            disabled
            style="width: 30%"
          ></el-input>
        </el-form-item>

        <el-form-item label="联系电话">
          <el-input
            placeholder="请输入联系电话"
            v-model="infoForm.phone"
            disabled
            oninput="
              value = value.replace(/[^\d]/g, '');
              if (value.length > 11) value = value.slice(0, 11);
            "
            style="width: 30%"
          ></el-input>
        </el-form-item>
        <el-form-item></el-form-item>
        <el-form-item label="店铺类型">
          <el-input
            placeholder="请输入店铺类型"
            v-model="infoForm.type"
            disabled
            style="width: 30%"
          ></el-input>
        </el-form-item>
        <h3>申请资料</h3>
        <el-form-item label="小程序名称">
          <el-input
            placeholder="请输入小程序名称"
            v-model="infoForm.miniAppName"
            disabled
            style="width: 30%"
          ></el-input>
        </el-form-item>
        <el-form-item label="小程序说明">
          <el-input
            type="textarea"
            v-model="infoForm.miniAppInfo"
            placeholder="请输入小程序说明"
            style="width: 30%"
            maxlength="120"
            show-word-limit
            disabled
            :rows="5"
          >
          </el-input>
          <!-- <quill-editor
            style="width: 80%"
            v-model="infoForm.miniAppInfo"
            ref="myQuillEditor"
            :options="editorOption"
            disabled
            class="editor"
          ></quill-editor> -->
        </el-form-item>
        <el-form-item label="小程序头像">
          <el-image
            :src="infoForm.miniAppTopImg"
            style="width: 120px; height: 120px"
            @click="look(infoForm.miniAppTopImg)"
          >
          </el-image>
          <!-- <headerPicture
            @getUrl="getImage($event)"
            :qrCodeUrl="infoForm.miniAppTopImg"
          ></headerPicture> -->
        </el-form-item>
        <el-form-item label="小程序管理员电话">
          <div>
            <el-input
              style="width: 30%"
              disabled
              placeholder="请输入电话"
              v-model="infoForm.miniAppManagerPhone"
              oninput="
              value = value.replace(/[^\d]/g, '');
              if (value.length > 11) value = value.slice(0, 11);
            "
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="管理员身份证正面">
          <el-image
            :src="infoForm.managerIdentifyTop"
            style="width: 300px; height: 150px"
            @click="look(infoForm.managerIdentifyTop)"
          >
          </el-image>
          <!-- <upload-means
            type="1"
            @getUrl="getUrl($event, '1')"
            :managerIdentifyTop="infoForm.managerIdentifyTop"
          ></upload-means> -->
        </el-form-item>
        <el-form-item label="管理员身份证反面" prop="name">
          <el-image
            :src="infoForm.managerIdentifyBottom"
            style="width: 300px; height: 150px"
            @click="look(infoForm.managerIdentifyBottom)"
          >
          </el-image>
          <!-- <upload-means
            type="2"
            @getUrl="getUrl($event, '2')"
            :managerIdentifyBottom="infoForm.managerIdentifyBottom"
          ></upload-means> -->
        </el-form-item>
        <el-form-item label="营业执照" prop="name">
          <el-image
            :src="infoForm.license"
            style="width: 300px; height: 150px"
            @click="look(infoForm.license)"
          >
          </el-image>
          <!-- <upload-means
            type="0"
            @getUrl="getUrl($event, '')"
            :license="infoForm.license"
          ></upload-means> -->
        </el-form-item>
      </el-form>
      <div style="width: 10%; text-align: center; padding-bottom: 20px">
        <!-- <el-button type="primary" @click="submit()">确认</el-button> -->
        <el-button @click="back">返回</el-button>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img
        width="100%"
        fit="contain"
        :src="dialogImageUrl"
        alt=""
        style="width: 100%"
      />
    </el-dialog>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import headerPicture from '@/components/upload/headerPicture.vue'
import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'
import imageResize from 'quill-image-resize-module' // 引用
import { ImageDrop } from 'quill-image-drop-module'
import UploadMeans from '../components/uploadMeans.vue'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', imageResize) // 注册
export default {
  components: {
    quillEditor,
    UploadMeans,
    headerPicture
  },
  data () {
    return {
      dialogVisible: false,
      dialogImageUrl: '',
      editorOption: {},
      infoForm: {
        id: '',
        name: '',
        phone: '',
        type: '',
        miniAppName: '',
        miniAppInfo: '',
        miniAppTopImg: '',
        miniAppManagerPhone: '',
        managerIdentifyTop: '',
        managerIdentifyBottom: '',
        license: ''
      },
      name: '---',
      dialogUser: false,
      tableData: [
        {}, {}, {}
      ]
    }
  },
  created () {
    this.getDetail(this.$route.query.id)
  },
  methods: {
    look (src) {
      this.dialogVisible = true
      this.dialogImageUrl = src
    },
    back () {
      this.$router.go(-1)
    },
    submit () {

      this.$api.editShopApplyDetail(this.infoForm).then(res => {
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '更改成功'
          });
          this.$router.push({
            name: 'shopApply',
            query: {}
          })
          // this.getDetail(this.$route.query.id)
        }
      })
    },
    getUrl (val, type) {
      if (type == '') {
        this.infoForm.license = val
      } else if (type == '1') {
        this.infoForm.managerIdentifyTop = val
      } else {
        this.infoForm.managerIdentifyBottom = val
      }
    },
    getImage (val) {
      this.infoForm.miniAppTopImg = val
    },
    getDetail (id) {
      let data = {
        id: id
      }
      this.$api.getShopApplyDetail(data).then(res => {
        if (res.code == 0) {
          this.infoForm = res.data
        }
      })
    }
  }
}
</script>
<style scoped>
.div1 {
  margin-left: -16px;
  background: url(../../../assets/breadcrumb2.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2d7edf;
}

.div2 {
  margin-left: -16px;
  background: url(../../../assets/breadcrumb1.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
}
.dialog-search {
  display: flex;
  width: 46%;
  justify-content: space-between;
  margin-top: 10px;
  margin-left: 10px;
}
</style>
